/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InternalApiAttachCasePersonsRequest
 */
export interface InternalApiAttachCasePersonsRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof InternalApiAttachCasePersonsRequest
     */
    externalIds: Array<string>;
}

/**
 * Check if a given object implements the InternalApiAttachCasePersonsRequest interface.
 */
export function instanceOfInternalApiAttachCasePersonsRequest(value: object): value is InternalApiAttachCasePersonsRequest {
    if (!('externalIds' in value) || value['externalIds'] === undefined) return false;
    return true;
}

export function InternalApiAttachCasePersonsRequestFromJSON(json: any): InternalApiAttachCasePersonsRequest {
    return InternalApiAttachCasePersonsRequestFromJSONTyped(json, false);
}

export function InternalApiAttachCasePersonsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiAttachCasePersonsRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'externalIds': json['externalIds'],
    };
}

export function InternalApiAttachCasePersonsRequestToJSON(json: any): InternalApiAttachCasePersonsRequest {
    return InternalApiAttachCasePersonsRequestToJSONTyped(json, false);
}

export function InternalApiAttachCasePersonsRequestToJSONTyped(value?: InternalApiAttachCasePersonsRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'externalIds': value['externalIds'],
    };
}

